export default __webpack_public_path__ + "static/media/onlineUsers.b6f30511.svg";